import { createRoute } from '@tanstack/react-router';

import { AdminBaseRouteLayout } from '$/routes/Admin/AdminBaseRouteLayout';
import { queryClient } from '$/services/client';

export const AdminCollectionsRoute = createRoute({
  getParentRoute: () => AdminBaseRouteLayout,
  path: '/admin/collections',
  onEnter: async () => {
    await queryClient.invalidateQueries({ queryKey: ['adminOptions'] });
  },
}).lazy(() => import('./AdminCollectionsRoute.lazy').then((d) => d.Route));
